import {useNavigate} from "react-router-dom";
import {useAtom} from "jotai";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "./Modal";
import styled, {css} from "styled-components";
import {FindIdResultAtom} from "../../pages/login";
const mainColor = css`${props => props.theme.color.mainColor}`
export function ComponentModalFindId(){
  const navigate = useNavigate()
  const [, setModal] = useAtom(modalController)
  const [findIdResult] = useAtom(FindIdResultAtom)
  const handleNavigate = () => {
    setModal({
      isShow: false,
      modalComponent: null
    })
    navigate('/login')
  }
  return (
    <div>
      <ModalHeader title={"아이디 찾기 결과"}/>
      <ModalBody>
        <FindIdResult>아이디 찾기 결과 <span>{findIdResult !== undefined && findIdResult.length}개</span>의 아이디가 존재합니다.</FindIdResult>
        <ModalBodyInner>
          <IdResultList>
            {findIdResult.length !== 0
                ? findIdResult.map((item, key) => (
                    <IdResultItem key={key}>{item}</IdResultItem>
                ))
                : <EmptyResult>일치하는 아이디가 없습니다.</EmptyResult>}
          </IdResultList>
        </ModalBodyInner>
      </ModalBody>
      <ModalFooter>
        <ModalButton $secondary onClick={() => {
          navigate('/findPassword')
          setModal({
            isShow: false,
            modalComponent: null
          })
        }}>비밀번호 찾기</ModalButton>
        <ModalButton onClick={handleNavigate}>로그인</ModalButton>
      </ModalFooter>
    </div>
  )
}

export function ComponentModalFindPassword(props) {
  const navigate = useNavigate()
  const [, setModal] = useAtom(modalController)
  const passwordParams = props
  const handleNavigate = () => {
    setModal({
      isShow: false,
      modalComponent: null
    })
    navigate('/login')
  }

  return(
    <div>
      <ModalHeader title={"비밀번호 찾기 결과"}/>
      <ModalBody>
        <FindIdResult>임시 비밀번호가 <span>{passwordParams.params.email}</span>(으)로 발급되었습니다.</FindIdResult>
        <ModalBodyInner>
          <IdResultList>
            <IdResultItem>{passwordParams.params.email}</IdResultItem>
          </IdResultList>
          <PasswordNotice>로그인 후 반드시 비밀번호를 변경해주시기 바랍니다.</PasswordNotice>
        </ModalBodyInner>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={handleNavigate}>로그인</ModalButton>
      </ModalFooter>
    </div>
  )
}

const FindIdResult = styled.div`
  margin-bottom: 16px;
  width: 100%;
  color: #444c54;
  font-size: var(--font-size-15);
  text-align: center;
  & span {
    color: ${mainColor};
    font-weight: 700;
  }
`

const ModalBodyInner = styled.div`
  padding: 18px 22px;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background-color: #f8fafc;
  color: #444c54;
  font-size: var(--font-size-15);
  line-height: 1.6;
`

const IdResultList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 220px;
  overflow-y: auto;
`

const IdResultItem = styled.p`
  margin: 0 !important;
  padding: 11px 14px;
  border: 1px solid #e5eaf0;
  border-radius: 7px;
  background: var(--color-surface);
  color: var(--color-text-strong);
  font-size: var(--font-size-15);
  font-weight: 700;
  text-align: center;
`

const EmptyResult = styled.p`
  margin: 0 !important;
  padding: 12px 0;
  color: #9aa3ad;
  font-size: var(--font-size-14);
  font-weight: 500;
  text-align: center;
`

const PasswordNotice = styled.p`
  margin: 12px 0 0 !important;
  padding: 10px 12px;
  border: 1px solid #fde68a;
  border-radius: 7px;
  background: #fffbeb;
  color: #92400e;
  font-size: var(--font-size-14);
  font-weight: 600;
  text-align: center;
`

const ModalButton = styled.button`
  && {
    width: auto;
    flex: 1;
    height: 46px;
    margin: 0 5px;
    padding: 0 18px;
    border: 1px solid ${({theme, $secondary}) => $secondary ? '#dfe3e7' : theme.color.subColor};
    border-radius: 8px;
    background-color: ${({theme, $secondary}) => $secondary ? 'var(--color-surface)' : theme.color.subColor};
    color: ${({$secondary}) => $secondary ? '#4b5563' : 'var(--color-surface)'};
    font-size: var(--font-size-15);
    font-weight: 700;
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease, transform .15s ease;
  }

  &&:hover {
    background-color: ${({theme, $secondary}) => $secondary ? '#f5f7fa' : theme.color.mainColor};
    border-color: ${({theme, $secondary}) => $secondary ? theme.color.subColor : theme.color.mainColor};
    transform: translateY(-1px);
  }
`
